import { RecruitListFilterModule_ActivityFilterListItemFragment } from 'generated/graphql'

const parseItem = (
  items: RecruitListFilterModule_ActivityFilterListItemFragment['items'],
) => {
  return (
    items?.map((item) => ({
      id: (item?.__typename === 'ActivityFilterItemByID' && item.dataId) || '',
      name: (item?.__typename === 'ActivityFilterItemByID' && item.name) || '',
    })) || []
  )
}

export default parseItem
